export default __webpack_public_path__ + "static/media/happyCouple.41b4e25d.jpg";